export function getTextWithConfigs(values: unknown[], ogText: string): string {
    return ogText.replace(/\{([0-9]+)\}/g,
        function (_, index: number) { return values[index] as string; });
}